




































































































import Modal from '@/components/Modal/Modal.vue'
import { Button, Icon } from '@alpha/ink'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import { normalizeSearchTerm } from '@/components/FilterBar.vue'
import store from '@/store'
import AjaxButton from '@/components/AjaxButton.vue'
import AudienceInfo from '../AudienceInfo.vue'
import SplitView from '@/components/SplitView.vue'
import { Vue, Component, Prop } from 'vue-property-decorator'
import AudienceBuilderSidebar from './AudienceBuilderSidebar.vue'
import AudienceSelectionContent from './AudienceSelectionContent.vue'
import AudienceBuilderContent from './AudienceBuilderContent.vue'
import * as ui from '@/types/frontend'
import $ from 'jquery'
import AudienceSelectionSidebar, { AudienceGroup } from './AudienceSelectionSidebar.vue'
import Audience, { audienceNameMaxLength, NewAudience, USAdultsAudience, AudienceCriteria, AudienceCriteriaType, GeographicLocationType, validateNewAudience, NewAudienceValidationError, NewAudienceValidationErrorType, formatAudienceForRR, clampUSHHINumberRange } from './Audience'
import { compact, difference, pick, isEqual } from 'lodash-es'
import api from '@/api'
import ConfirmExitPopup from '@/components/TestDetails/DefaultTestCreation/ConfirmExitPopup.vue'
import Overlay from '@/components/Overlay.vue'
import analytics from '@/analytics'
export { getSelectableAudiences } from './Audience'

export enum AudienceLibraryStage {
  AudienceSelection = 'AudienceSelection',
  AudienceBuilder = 'AudienceBuilder'
}

const defaultAudience: NewAudience = {
  name: '',
  criteria: {
    [AudienceCriteriaType.AGE]: [18, 75],
    [AudienceCriteriaType.GEOGRAPHIC_LOCATION]: {
      type: GeographicLocationType.USA
    }
  }
}

function truncateAudienceName (audienceName: string) {
  const ellipsis = '...'
  const truncatedSize = audienceNameMaxLength - ellipsis.length
  if (audienceName.length <= truncatedSize) {
    return audienceName
  }

  return [audienceName.slice(0, truncatedSize), ellipsis].join('')
}

@Component({
  components: {
    Modal,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Button,
    AjaxButton,
    AudienceInfo,
    AudienceSelectionSidebar,
    AudienceBuilderSidebar,
    AudienceSelectionContent,
    AudienceBuilderContent,
    ConfirmExitPopup,
    SplitView,
    Overlay,
    Icon
  }
})
export default class AudienceManagerModal extends Vue {
  @Prop({ required: true }) readonly audiences!: Audience[]
  @Prop({ default: null }) readonly initialSelectedAudienceId!: string | null
  @Prop({ required: true }) readonly workspaceId!: string
  @Prop({ required: true }) readonly accountId!: string

  defaultCriteria = defaultAudience.criteria
  newAudience = { ...defaultAudience }
  selectedAudienceId = this.initialSelectedAudienceId
  audienceStage = AudienceLibraryStage.AudienceSelection
  AudienceLibraryStage = AudienceLibraryStage
  searchFilter: ui.Filter<{}> = { searchTerm: '' }
  activeCriteriaTypes: AudienceCriteriaType[] = [
    AudienceCriteriaType.AGE,
    AudienceCriteriaType.GEOGRAPHIC_LOCATION
  ]

  criteriaTypesWithNoOptionsSelected: AudienceCriteriaType[] = []
  savingAudience = false

  validationErrors: NewAudienceValidationError[] = []

  cancelAlert = false
  saveAlert = false
  redirectToLibrary = false

  get selectedAudience () {
    const audiences = [USAdultsAudience, ...this.audiences]
    return audiences.find(a => a.id === this.selectedAudienceId)
  }

  get sortedAudiences () {
    return this.audiences.sort((a, b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
  }

  filterAudiencesBySearchTerm (audiences: Audience[]): Audience[] {
    const { searchTerm } = this.searchFilter
    if (!searchTerm) return audiences
    const normalizedSearchTerm = normalizeSearchTerm(searchTerm)
    return audiences.filter(a => a.name.toLowerCase().includes(normalizedSearchTerm))
  }

  get featuredAudiences () {
    return this.filterAudiencesBySearchTerm([USAdultsAudience])
  }

  get customAudiences () {
    return this.filterAudiencesBySearchTerm(this.sortedAudiences)
  }

  get audienceGroups (): AudienceGroup[] {
    const result = [
      {
        title: 'Featured audiences',
        description: '<b>Featured Audiences</b> reflect some of the most frequently-accessed test participant types used by Feedback Loop clients.',
        audiences: this.featuredAudiences
      }
    ]

    if (this.audiences.length > 0) {
      result.push({
        title: 'CUSTOM AUDIENCES',
        description: '<b>Custom Audiences</b> are available to all workspaces across your organization',
        audiences: this.customAudiences
      })
    }

    return result
  }

  get hasInternationalFeature () {
    return store.getters.feature.hasFeature('internationalSelector')
  }

  get internationalConfigs () {
    return store.getters.feature.featureConfig('internationalSelector')
  }

  get selectionsMade () {
    return this.activeCriteriaTypes.some(type => {
      return !isEqual(this.newAudience.criteria[type], this.defaultCriteria[type])
    })
  }

  get hasChanges () {
    return this.selectionsMade || this.newAudience.name
  }

  get listOfCriteriaForPopupDialog () {
    return this.criteriaTypesWithNoOptionsSelected.join('<br>')
  }

  back () {
    if (this.audienceStage === AudienceLibraryStage.AudienceSelection) {
      this.close()
    } else {
      if (this.hasChanges) {
        this.cancelAlert = true
        this.redirectToLibrary = true
      } else {
        this.validationErrors = []
        this.setStage(AudienceLibraryStage.AudienceSelection)
      }
    }
  }

  confirmExitAction () {
    if (this.redirectToLibrary) {
      this.validationErrors = []
      this.setStage(AudienceLibraryStage.AudienceSelection)
    } else {
      this.$emit('close')
    }
  }

  scrollToCriteria (criteriaType: AudienceCriteriaType) {
    const splitViewPanel = (this.$refs.splitView as Vue).$refs.scrollArea
    const position = criteriaType === AudienceCriteriaType.ADDITIONAL ? 0 : ((this.$refs.splitView as Vue).$refs.scrollArea as HTMLElement).scrollHeight
    $(splitViewPanel).animate({ scrollTop: position })
  }

  scrollToTop () {
    const splitViewPanel = (this.$refs.splitView as Vue).$refs.scrollArea
    $(splitViewPanel).animate({ scrollTop: 0 })
  }

  setStage (stage: AudienceLibraryStage) {
    if (stage === AudienceLibraryStage.AudienceSelection) {
      this.cancelAlert = false
      this.redirectToLibrary = false
    }
    this.audienceStage = stage
    this.scrollToTop()
  }

  setSearchFilter (newSearchFilter: ui.Filter<{}>) {
    this.searchFilter = newSearchFilter
  }

  setNewAudienceName (name: string) {
    this.newAudience.name = name
  }

  setSelectedAudience (audienceId: string) {
    this.selectedAudienceId = audienceId
  }

  clearEmptyCriteriaTypes () {
    this.activeCriteriaTypes = difference(this.activeCriteriaTypes, this.criteriaTypesWithNoOptionsSelected)
    this.saveAlert = false
    this.selectAudience()
  }

  async selectAudience () {
    if (this.audienceStage === AudienceLibraryStage.AudienceBuilder) {
      this.validationErrors = []
      const newAudience: NewAudience = {
        ...this.newAudience,
        // Only include criteria types that the user selected.
        criteria: pick(this.newAudience.criteria, this.activeCriteriaTypes)
      }

      const existingAudienceNames = this.audiences.map(a => a.name)
      const validationErrorsAndWarnings = validateNewAudience(newAudience, existingAudienceNames)
      const validationErrors = compact(validationErrorsAndWarnings.map(e => e.type !== NewAudienceValidationErrorType.NO_OPTIONS_SELECTED && e))
      const criteriaTypesWithNoOptionsSelected = compact(validationErrorsAndWarnings.map(e => e.type === NewAudienceValidationErrorType.NO_OPTIONS_SELECTED && e.criteriaType))

      if (validationErrors.length > 0) {
        this.validationErrors = validationErrors
        this.scrollToTop()
        return
      } else if (criteriaTypesWithNoOptionsSelected.length > 0) {
        this.criteriaTypesWithNoOptionsSelected = criteriaTypesWithNoOptionsSelected
        this.saveAlert = true
        return
      } else {
        this.savingAudience = true
        const addedAudience = await this.saveNewAudience(newAudience)
        this.$emit('setAudience', addedAudience)
        this.savingAudience = false
      }
    } else {
      this.$emit('setAudience', this.selectedAudience)
    }

    this.$emit('close')
  }

  async saveNewAudience (newAudience: NewAudience): Promise<Audience> {
    const formattedAudienceForRR = formatAudienceForRR(newAudience)
    const createAudienceResult: {
      data: {
        'account_id': string
        'audience_id': string
        id: string
      }
    } = await api.createAudience(this.workspaceId, formattedAudienceForRR)
    const newAudienceResult = await api.getAudienceById(createAudienceResult.data.id, this.accountId)
    store.commit.workspace.addAccountAudience(newAudienceResult)

    if (newAudience.duplicated) {
      analytics.track('duplicateAudience', {
        previousAudienceId: newAudience.duplicated,
        newAudienceId: newAudienceResult._id
      })
    }

    return {
      ...newAudience,
      id: createAudienceResult.data.id
    }
  }

  close () {
    if (this.audienceStage === AudienceLibraryStage.AudienceBuilder && this.hasChanges) {
      this.cancelAlert = true
    } else {
      this.$emit('close')
    }
  }

  updateNewAudienceCriteria (updatedCriteria: Partial<AudienceCriteria>) {
    this.newAudience.criteria = {
      ...this.newAudience.criteria,
      ...updatedCriteria
    }
  }

  setCriteriaTypeActive (criteriaType: AudienceCriteriaType, active: boolean) {
    if (active) {
      // Add criteria type to list
      if (!this.activeCriteriaTypes.includes(criteriaType)) {
        this.activeCriteriaTypes = [...this.activeCriteriaTypes, criteriaType]
        // Scroll to criteria
        this.scrollToCriteria(criteriaType)
      }
    } else {
      this.activeCriteriaTypes = this.activeCriteriaTypes.filter(t => t !== criteriaType)
    }

    switch (criteriaType) {
      // Age and Geographic Location cannot be disabled.
      case AudienceCriteriaType.AGE:
      case AudienceCriteriaType.GEOGRAPHIC_LOCATION:
        break
      case AudienceCriteriaType.US_HHI:
        this.newAudience.criteria[criteriaType] = [0, 0]
        break
      case AudienceCriteriaType.ADDITIONAL:
        this.newAudience.criteria[criteriaType] = ''
        break
      default:
        this.newAudience.criteria[criteriaType] = []
        break
    }
  }

  duplicateAudience () {
    if (this.selectedAudience) {
      const hhiRange = this.selectedAudience.criteria[AudienceCriteriaType.US_HHI]
      const newAudience = {
        name: truncateAudienceName(this.selectedAudience.name),
        criteria: {
          ...this.selectedAudience.criteria,
          // We clamp the HHI range since the new HHI selector doesn't support the bucket
          // granularity of existing Audiences.
          [AudienceCriteriaType.US_HHI]: hhiRange !== undefined
            ? clampUSHHINumberRange(hhiRange)
            : undefined
        },
        duplicated: this.selectedAudience.id
      }
      this.createNewAudience(newAudience)
    }
  }

  createNewAudience (newAudience: NewAudience = defaultAudience) {
    this.newAudience = { ...newAudience }
    this.activeCriteriaTypes = Object.values(AudienceCriteriaType)
      .filter(audienceCriteriaType => newAudience.criteria[audienceCriteriaType] !== undefined)
    this.setStage(AudienceLibraryStage.AudienceBuilder)
  }
}
